import { createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";
import { CustomersTypes } from "./customers-actions";

export const INITIAL_STATE = Immutable({
    fetchingCustomers: false,
    fetchingCustomersCount: false,
    fetchingCustomerImports: false,
    fetchingCustomerImport: false,
    uploading: false,
    applyingUpload: false,
    fetchingEntries: false,
    fetchingAudienceMembers: false,
    fetchingAudienceCandidateSegments: false,
    fetchingAudienceCandidateTags: false,
    savingAudienceCandidateMetadata: false,
    applyingAudienceCandidates: false,
    fetchingAudienceBulkInvitations: false,
    fetchingAudienceBatches: false,
    downloadingCsv: false,
    downloadingAudienceCsv: false,
    submittingCustomerEnrichment: false,
    fetchingCustomerEnrichments: false,
    fetchingCustomerEnrichmentStatus: false,
    fetchingCustomerEnrichmentItems: false,
    bulkPlanInviting: false,
    fetchingBusinessCustomerRecord: false,
    linkingBusinessCustomer: false,
    unlinkingBusinessCustomer: false,
    fetchingCanonicalBusinessCustomer: false,
    fetchingBusinessCustomerSummary: false,
    fetchingSecondaryBusinessCustomers: false,
    fetchingSecondaryBusinessCustomersCount: false,
    creatingBusinessCustomer: false,
    updatingBusinessCustomerSimple: false,
    creatingAudience: false,

    customers: null,
    counts: null,
    customerImports: null,
    customerImport: null,
    documentUpload: null,
    documentUploadApplied: null,
    customerEntries: null,
    audienceMembers: null,
    audienceCandidateSegments: null,
    audienceCandidateTags: null,
    audienceCandidateMetadataSaved: null,
    audienceCandidatesApplied: null,
    audienceBulkInvitations: null,
    audienceBatches: null,
    downloadedCsv: null,
    downloadedAudienceCsv: null,
    customerEnrichment: null,
    customerEnrichments: null,
    customerEnrichmentStatus: null,
    customerEnrichmentItems: null,
    customerEnrichmentItemsRequestId: null,
    bulkPlanInvite: null,
    businessCustomerRecord: null,
    linkedBusinessCustomer: null,
    canonicalBusinessCustomer: null,
    businessCustomerSummary: null,
    secondaryBusinessCustomers: null,
    secondaryBusinessCustomersCount: null,
    createdBusinessCustomer: null,
    updatedBusinessCustomerSimple: null,
    createdAudience: null,

    errorCustomers: null,
    errorCounts: null,
    errorCustomerImports: null,
    errorCustomerImport: null,
    errorUploading: null,
    errorApplyingUpload: null,
    errorFetchingEntries: null,
    errorAudienceMembers: null,
    errorAudienceCandidateSegments: null,
    errorAudienceCandidateTags: null,
    errorSaveAudienceCandidateMetadata: null,
    errorApplyAudienceCandidates: null,
    errorAudienceBulkInvitations: null,
    errorAudienceBatches: null,
    downloadCsvError: null,
    errorDownloadAudienceCsv: null,
    errorSubmitCustomerEnrichment: null,
    errorCustomerEnrichments: null,
    errorCustomerEnrichmentStatus: null,
    errorCustomerEnrichmentItems: null,
    errorBulkPlanInvite: null,
    businessCustomersError: null,
    errorLinkBusinessCustomer: null,
    errorUnlinkBusinessCustomer: null,
    errorCanonicalBusinessCustomer: null,
    errorBusinessCustomerSummary: null,
    errorSecondaryBusinessCustomers: null,
    errorSecondaryBusinessCustomersCount: null,
    errorCreateBusinessCustomer: null,
    errorUpdateBusinessCustomerSimple: null,
    errorCreateAudience: null,
})


// request data from an api 
export const businessCustomerRecordRequest = (state) => { return { ...state, fetchingBusinessCustomerRecord: true, businessCustomerRecord: null } }

export const linkBusinessCustomerRequest = (state) => ({
    ...state,
    linkingBusinessCustomer: true,
    linkedBusinessCustomer: null,
    errorLinkBusinessCustomer: null,
})

export const unlinkBusinessCustomerRequest = (state) => ({
    ...state,
    unlinkingBusinessCustomer: true,
    linkedBusinessCustomer: null,
    errorUnlinkBusinessCustomer: null,
})

export const canonicalBusinessCustomerRequest = (state) => ({
    ...state,
    fetchingCanonicalBusinessCustomer: true,
    canonicalBusinessCustomer: null,
    errorCanonicalBusinessCustomer: null,
})

export const businessCustomerSummaryRequest = (state) => ({
    ...state,
    fetchingBusinessCustomerSummary: true,
    businessCustomerSummary: null,
    errorBusinessCustomerSummary: null,
})

export const secondaryBusinessCustomersRequest = (state) => ({
    ...state,
    fetchingSecondaryBusinessCustomers: true,
    secondaryBusinessCustomers: null,
    errorSecondaryBusinessCustomers: null,
})

export const secondaryBusinessCustomersCountRequest = (state) => ({
    ...state,
    fetchingSecondaryBusinessCustomersCount: true,
    secondaryBusinessCustomersCount: null,
    errorSecondaryBusinessCustomersCount: null,
})

export const createBusinessCustomerRequest = (state) => ({
    ...state,
    creatingBusinessCustomer: true,
    createdBusinessCustomer: null,
    errorCreateBusinessCustomer: null,
})

export const updateBusinessCustomerSimpleRequest = (state) => ({
    ...state,
    updatingBusinessCustomerSimple: true,
    updatedBusinessCustomerSimple: null,
    errorUpdateBusinessCustomerSimple: null,
})

export const createAudienceRequest = (state) => ({
    ...state,
    creatingAudience: true,
    createdAudience: null,
    errorCreateAudience: null,
})

export const bulkPlanInviteRequest = (state) => {
    return { ...state, bulkPlanInviting: true, bulkPlanInvite: null, errorBulkPlanInvite: null }
}

export const downloadCsvRequest = (state) => {
    return { ...state, downloadingCsv: true, downloadedCsv: null, downloadCsvError: null }
}

export const downloadAudienceCsvRequest = (state) => {
    return { ...state, downloadingAudienceCsv: true, downloadedAudienceCsv: null, errorDownloadAudienceCsv: null }
}

export const submitCustomerEnrichmentRequest = (state) => {
    return {
        ...state,
        submittingCustomerEnrichment: true,
        customerEnrichment: null,
        errorSubmitCustomerEnrichment: null,
    }
}

export const customerEnrichmentsRequest = (state) => {
    return {
        ...state,
        fetchingCustomerEnrichments: true,
        errorCustomerEnrichments: null,
    }
}

export const customerEnrichmentStatusRequest = (state) => {
    return {
        ...state,
        fetchingCustomerEnrichmentStatus: true,
        errorCustomerEnrichmentStatus: null,
    }
}

export const customerEnrichmentItemsRequest = (state) => {
    return {
        ...state,
        fetchingCustomerEnrichmentItems: true,
        errorCustomerEnrichmentItems: null,
    }
}

export const customersRequest = (state) => {
    return { ...state, fetchingCustomers: true }
}
export const customersCountRequest = (state) => {
    return { ...state, fetchingCustomersCount: true }
}
export const customerImportsRequest = (state) => {
    return { ...state, fetchingCustomerImports: true, customerImports: null }
}
export const customerImportRequest = (state) => {
    return { ...state, fetchingCustomerImport: true, customerImport: null }
}
export const uploadRequest = (state) => {
    return { ...state, uploading: true, documentUpload: null }
}
export const applyUpload = (state) => {
    return { ...state, applyingUpload: true, documentUploadApplied: null }
}
export const entriesRequest = (state) => {
    return { ...state, fetchingEntries: true, customerEntries: null }
}
export const audienceMembersRequest = (state) => {
    return { ...state, fetchingAudienceMembers: true, audienceMembers: null, errorAudienceMembers: null }
}

export const audienceCandidateSegmentsRequest = (state) => {
    return {
        ...state,
        fetchingAudienceCandidateSegments: true,
        audienceCandidateSegments: null,
        errorAudienceCandidateSegments: null,
    }
}

export const audienceCandidateTagsRequest = (state) => {
    return {
        ...state,
        fetchingAudienceCandidateTags: true,
        audienceCandidateTags: null,
        errorAudienceCandidateTags: null,
    }
}

export const saveAudienceCandidateMetadataRequest = (state) => ({
    ...state,
    savingAudienceCandidateMetadata: true,
    audienceCandidateMetadataSaved: null,
    errorSaveAudienceCandidateMetadata: null,
})

export const applyAudienceCandidatesRequest = (state) => ({
    ...state,
    applyingAudienceCandidates: true,
    audienceCandidatesApplied: null,
    errorApplyAudienceCandidates: null,
})

export const audienceBulkInvitationsRequest = (state) => ({
    ...state,
    fetchingAudienceBulkInvitations: true,
    audienceBulkInvitations: null,
    errorAudienceBulkInvitations: null,
})

export const audienceBatchesRequest = (state) => ({
    ...state,
    fetchingAudienceBatches: true,
    audienceBatches: null,
    errorAudienceBatches: null,
})


// successful api lookup for business customer record
export const businessCustomerRecordSuccess = (state, action) => {
    const { customerRecord } = action
    return {
        ...state,
        fetchingBusinessCustomerRecord: false,
        businessCustomerRecord: customerRecord,
        businessCustomerRecordError: null
    }
}

export const linkBusinessCustomerSuccess = (state, action) => {
    const { businessCustomer } = action
    return {
        ...state,
        linkingBusinessCustomer: false,
        linkedBusinessCustomer: businessCustomer,
        errorLinkBusinessCustomer: null,
    }
}

export const unlinkBusinessCustomerSuccess = (state, action) => {
    const { businessCustomer } = action
    return {
        ...state,
        unlinkingBusinessCustomer: false,
        linkedBusinessCustomer: businessCustomer,
        errorUnlinkBusinessCustomer: null,
    }
}

export const canonicalBusinessCustomerSuccess = (state, action) => {
    const { businessCustomer } = action
    return {
        ...state,
        fetchingCanonicalBusinessCustomer: false,
        canonicalBusinessCustomer: businessCustomer,
        errorCanonicalBusinessCustomer: null,
    }
}

export const businessCustomerSummarySuccess = (state, action) => {
    const { businessCustomerSummary } = action
    return {
        ...state,
        fetchingBusinessCustomerSummary: false,
        businessCustomerSummary,
        errorBusinessCustomerSummary: null,
    }
}

export const secondaryBusinessCustomersSuccess = (state, action) => {
    const { secondaryBusinessCustomers } = action
    return {
        ...state,
        fetchingSecondaryBusinessCustomers: false,
        secondaryBusinessCustomers,
        errorSecondaryBusinessCustomers: null,
    }
}

export const secondaryBusinessCustomersCountSuccess = (state, action) => {
    const { secondaryBusinessCustomersCount } = action
    return {
        ...state,
        fetchingSecondaryBusinessCustomersCount: false,
        secondaryBusinessCustomersCount,
        errorSecondaryBusinessCustomersCount: null,
    }
}

export const createBusinessCustomerSuccess = (state, action) => {
    const { businessCustomer } = action
    return {
        ...state,
        creatingBusinessCustomer: false,
        createdBusinessCustomer: businessCustomer,
        errorCreateBusinessCustomer: null,
    }
}

export const updateBusinessCustomerSimpleSuccess = (state, action) => {
    const { businessCustomer } = action
    return {
        ...state,
        updatingBusinessCustomerSimple: false,
        updatedBusinessCustomerSimple: businessCustomer,
        errorUpdateBusinessCustomerSimple: null,
    }
}

export const createAudienceSuccess = (state, action) => {
    const { audience } = action
    return {
        ...state,
        creatingAudience: false,
        createdAudience: audience,
        errorCreateAudience: null,
    }
}

export const bulkPlanInviteSuccess = (state, action) => {
    const { details } = action;
    return { ...state, bulkPlanInviting: false, bulkPlanInvite: details, errorBulkPlanInvite: null }
}

export const downloadCsvSuccess = (state, action) => {
    const { csv } = action;
    return { ...state, downloadingCsv: false, downloadedCsv: csv, downloadCsvError: null }
}

export const downloadAudienceCsvSuccess = (state, action) => {
    const { csv } = action;
    return { ...state, downloadingAudienceCsv: false, downloadedAudienceCsv: csv, errorDownloadAudienceCsv: null }
}

export const submitCustomerEnrichmentSuccess = (state, action) => {
    const { customerEnrichment } = action;
    return {
        ...state,
        submittingCustomerEnrichment: false,
        customerEnrichment,
        customerEnrichmentStatus: customerEnrichment,
        errorSubmitCustomerEnrichment: null,
    }
}

export const customerEnrichmentsSuccess = (state, action) => {
    const { customerEnrichments } = action;
    return {
        ...state,
        fetchingCustomerEnrichments: false,
        customerEnrichments,
        errorCustomerEnrichments: null,
    }
}

export const customerEnrichmentStatusSuccess = (state, action) => {
    const { customerEnrichmentStatus } = action;
    return {
        ...state,
        fetchingCustomerEnrichmentStatus: false,
        customerEnrichmentStatus,
        errorCustomerEnrichmentStatus: null,
    }
}

export const customerEnrichmentItemsSuccess = (state, action) => {
    const { customerEnrichmentItems, requestId } = action;
    return {
        ...state,
        fetchingCustomerEnrichmentItems: false,
        customerEnrichmentItems,
        customerEnrichmentItemsRequestId: requestId,
        errorCustomerEnrichmentItems: null,
    }
}

export const customersSuccess = (state, action) => {
    const { customers } = action;
    return { ...state, customers, errorCustomers: null }
}
export const customersCountSuccess = (state, action) => {
    const { counts } = action;
    return { ...state, counts, errorCustomers: null }
}
export const customerImportsSuccess = (state, action) => {
    const { customerImports } = action;
    return { ...state, fetchingCustomerImports: false, errorCustomerImports: null, customerImports: customerImports }
}

export const customerImportSuccess = (state, action) => {
    const { customerImport } = action;
    return { ...state, fetchingCustomerImport: false, errorCustomerImport: null, customerImport: customerImport }
}

export const uploadSuccess = (state, action) => {
    const { document } = action;
    return { ...state, uploading: false, errorUploading: null, documentUpload: document }
}

export const applyUploadSuccess = (state, action) => {
    const { fileImported } = action
    return { ...state, applyingUpload: false, errorApplyingUpload: null, documentUploadApplied: fileImported }
}

export const entriesSuccess = (state, action) => {
    const { entriesList } = action
    return { ...state, fetchingEntries: false, errorFetchingEntries: null, customerEntries: entriesList }
}

export const audienceMembersSuccess = (state, action) => {
    const { audienceMembers } = action
    return {
        ...state,
        fetchingAudienceMembers: false,
        errorAudienceMembers: null,
        audienceMembers,
    }
}

export const audienceCandidateSegmentsSuccess = (state, action) => {
    const { audienceCandidateSegments } = action
    return {
        ...state,
        fetchingAudienceCandidateSegments: false,
        errorAudienceCandidateSegments: null,
        audienceCandidateSegments,
    }
}

export const audienceCandidateTagsSuccess = (state, action) => {
    const { audienceCandidateTags } = action
    return {
        ...state,
        fetchingAudienceCandidateTags: false,
        errorAudienceCandidateTags: null,
        audienceCandidateTags,
    }
}

export const saveAudienceCandidateMetadataSuccess = (state, action) => {
    const { audienceCandidateMetadata } = action
    return {
        ...state,
        savingAudienceCandidateMetadata: false,
        errorSaveAudienceCandidateMetadata: null,
        audienceCandidateMetadataSaved: audienceCandidateMetadata,
    }
}

export const applyAudienceCandidatesSuccess = (state, action) => {
    const { applyCandidatesResult } = action
    return {
        ...state,
        applyingAudienceCandidates: false,
        errorApplyAudienceCandidates: null,
        audienceCandidatesApplied: applyCandidatesResult,
    }
}

export const audienceBulkInvitationsSuccess = (state, action) => {
    const { audienceBulkInvitations } = action
    return {
        ...state,
        fetchingAudienceBulkInvitations: false,
        errorAudienceBulkInvitations: null,
        audienceBulkInvitations,
    }
}

export const audienceBatchesSuccess = (state, action) => {
    const { audienceBatches } = action
    return {
        ...state,
        fetchingAudienceBatches: false,
        errorAudienceBatches: null,
        audienceBatches,
    }
}


// Something went wrong fetching business customer record 
export const businessCustomerRecordFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        fetchingBusinessCustomerRecord: false,
        businessCustomerRecord: null,
        businessCustomerRecordError: error
    }
}

export const linkBusinessCustomerFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        linkingBusinessCustomer: false,
        linkedBusinessCustomer: null,
        errorLinkBusinessCustomer: error,
    }
}

export const unlinkBusinessCustomerFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        unlinkingBusinessCustomer: false,
        linkedBusinessCustomer: null,
        errorUnlinkBusinessCustomer: error,
    }
}

export const canonicalBusinessCustomerFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        fetchingCanonicalBusinessCustomer: false,
        canonicalBusinessCustomer: null,
        errorCanonicalBusinessCustomer: error,
    }
}

export const businessCustomerSummaryFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        fetchingBusinessCustomerSummary: false,
        businessCustomerSummary: null,
        errorBusinessCustomerSummary: error,
    }
}

export const secondaryBusinessCustomersFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        fetchingSecondaryBusinessCustomers: false,
        secondaryBusinessCustomers: null,
        errorSecondaryBusinessCustomers: error,
    }
}

export const secondaryBusinessCustomersCountFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        fetchingSecondaryBusinessCustomersCount: false,
        secondaryBusinessCustomersCount: null,
        errorSecondaryBusinessCustomersCount: error,
    }
}

export const createBusinessCustomerFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        creatingBusinessCustomer: false,
        createdBusinessCustomer: null,
        errorCreateBusinessCustomer: error,
    }
}

export const updateBusinessCustomerSimpleFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        updatingBusinessCustomerSimple: false,
        updatedBusinessCustomerSimple: null,
        errorUpdateBusinessCustomerSimple: error,
    }
}

export const createAudienceFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        creatingAudience: false,
        createdAudience: null,
        errorCreateAudience: error,
    }
}

export const bulkPlanInviteFailure = (state, action) => {
    const { error } = action;
    return { ...state, bulkPlanInviting: false, errorBulkPlanInvite: error, bulkPlanInvite: null }
}

export const downloadCsvFailure = (state, action) => {
    const { error } = action;
    return { ...state, downloadingCsv: false, downloadCsvError: error, downloadedCsv: null }
}

export const downloadAudienceCsvFailure = (state, action) => {
    const { error } = action;
    return { ...state, downloadingAudienceCsv: false, errorDownloadAudienceCsv: error, downloadedAudienceCsv: null }
}

export const submitCustomerEnrichmentFailure = (state, action) => {
    const { error } = action;
    return {
        ...state,
        submittingCustomerEnrichment: false,
        errorSubmitCustomerEnrichment: error,
        customerEnrichment: null,
    }
}

export const customerEnrichmentsFailure = (state, action) => {
    const { error } = action;
    return {
        ...state,
        fetchingCustomerEnrichments: false,
        errorCustomerEnrichments: error,
        customerEnrichments: null,
    }
}

export const customerEnrichmentStatusFailure = (state, action) => {
    const { error } = action;
    return {
        ...state,
        fetchingCustomerEnrichmentStatus: false,
        errorCustomerEnrichmentStatus: error,
    }
}

export const customerEnrichmentItemsFailure = (state, action) => {
    const { error } = action;
    return {
        ...state,
        fetchingCustomerEnrichmentItems: false,
        errorCustomerEnrichmentItems: error,
        customerEnrichmentItems: null,
        customerEnrichmentItemsRequestId: null,
    }
}

export const customersFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorCustomers: error, fetchingCustomers: false }
}

export const customersCountFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorCustomers: error, fetchingCustomers: false }
}
export const customerImportsFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorCustomerImports: error, fetchingCustomerImports: false }
}

export const customerImportFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorCustomerImport: error, fetchingCustomerImport: false }
}
export const uploadFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorUploading: error, uploading: false }
}

export const applyUploadFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorApplyingUpload: error, applyingUpload: false }
}

export const entriesFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorFetchingEntries: error, fetchingEntries: false }
}

export const audienceMembersFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorAudienceMembers: error, fetchingAudienceMembers: false, audienceMembers: null }
}

export const audienceCandidateSegmentsFailure = (state, action) => {
    const { error } = action;
    return {
        ...state,
        errorAudienceCandidateSegments: error,
        fetchingAudienceCandidateSegments: false,
        audienceCandidateSegments: null,
    }
}

export const audienceCandidateTagsFailure = (state, action) => {
    const { error } = action;
    return {
        ...state,
        errorAudienceCandidateTags: error,
        fetchingAudienceCandidateTags: false,
        audienceCandidateTags: null,
    }
}

export const saveAudienceCandidateMetadataFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        savingAudienceCandidateMetadata: false,
        audienceCandidateMetadataSaved: null,
        errorSaveAudienceCandidateMetadata: error,
    }
}

export const applyAudienceCandidatesFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        applyingAudienceCandidates: false,
        audienceCandidatesApplied: null,
        errorApplyAudienceCandidates: error,
    }
}

export const audienceBulkInvitationsFailure = (state, action) => {
    const { error } = action;
    return {
        ...state,
        errorAudienceBulkInvitations: error,
        fetchingAudienceBulkInvitations: false,
        audienceBulkInvitations: null,
    }
}

export const audienceBatchesFailure = (state, action) => {
    const { error } = action;
    return {
        ...state,
        errorAudienceBatches: error,
        fetchingAudienceBatches: false,
        audienceBatches: null,
    }
}

export const reducer = createReducer(INITIAL_STATE, {
    [CustomersTypes.CUSTOMERS_REQUEST]: customersRequest,
    [CustomersTypes.CUSTOMERS_COUNT_REQUEST]: customersCountRequest,
    [CustomersTypes.CUSTOMER_IMPORTS_REQUEST]: customerImportsRequest,
    [CustomersTypes.CUSTOMER_IMPORT_REQUEST]: customerImportRequest,
    [CustomersTypes.UPLOAD_REQUEST]: uploadRequest,
    [CustomersTypes.APPLY_UPLOAD]: applyUpload,
    [CustomersTypes.ENTRIES_REQUEST]: entriesRequest,
    [CustomersTypes.AUDIENCE_MEMBERS_REQUEST]: audienceMembersRequest,
    [CustomersTypes.AUDIENCE_CANDIDATE_SEGMENTS_REQUEST]: audienceCandidateSegmentsRequest,
    [CustomersTypes.AUDIENCE_CANDIDATE_TAGS_REQUEST]: audienceCandidateTagsRequest,
    [CustomersTypes.SAVE_AUDIENCE_CANDIDATE_METADATA_REQUEST]: saveAudienceCandidateMetadataRequest,
    [CustomersTypes.APPLY_AUDIENCE_CANDIDATES_REQUEST]: applyAudienceCandidatesRequest,
    [CustomersTypes.AUDIENCE_BULK_INVITATIONS_REQUEST]: audienceBulkInvitationsRequest,
    [CustomersTypes.AUDIENCE_BATCHES_REQUEST]: audienceBatchesRequest,
    [CustomersTypes.DOWNLOAD_CSV_REQUEST]: downloadCsvRequest,
    [CustomersTypes.DOWNLOAD_AUDIENCE_CSV_REQUEST]: downloadAudienceCsvRequest,
    [CustomersTypes.SUBMIT_CUSTOMER_ENRICHMENT_REQUEST]: submitCustomerEnrichmentRequest,
    [CustomersTypes.CUSTOMER_ENRICHMENTS_REQUEST]: customerEnrichmentsRequest,
    [CustomersTypes.CUSTOMER_ENRICHMENT_STATUS_REQUEST]: customerEnrichmentStatusRequest,
    [CustomersTypes.CUSTOMER_ENRICHMENT_ITEMS_REQUEST]: customerEnrichmentItemsRequest,
    [CustomersTypes.BULK_PLAN_INVITE_REQUEST]: bulkPlanInviteRequest,
    [CustomersTypes.BUSINESS_CUSTOMER_RECORD_REQUEST]: businessCustomerRecordRequest,
    [CustomersTypes.LINK_BUSINESS_CUSTOMER_REQUEST]: linkBusinessCustomerRequest,
    [CustomersTypes.UNLINK_BUSINESS_CUSTOMER_REQUEST]: unlinkBusinessCustomerRequest,
    [CustomersTypes.CANONICAL_BUSINESS_CUSTOMER_REQUEST]: canonicalBusinessCustomerRequest,
    [CustomersTypes.BUSINESS_CUSTOMER_SUMMARY_REQUEST]: businessCustomerSummaryRequest,
    [CustomersTypes.SECONDARY_BUSINESS_CUSTOMERS_REQUEST]: secondaryBusinessCustomersRequest,
    [CustomersTypes.SECONDARY_BUSINESS_CUSTOMERS_COUNT_REQUEST]: secondaryBusinessCustomersCountRequest,
    [CustomersTypes.CREATE_BUSINESS_CUSTOMER_REQUEST]: createBusinessCustomerRequest,
    [CustomersTypes.UPDATE_BUSINESS_CUSTOMER_SIMPLE_REQUEST]: updateBusinessCustomerSimpleRequest,
    [CustomersTypes.CREATE_AUDIENCE_REQUEST]: createAudienceRequest,

    [CustomersTypes.CUSTOMERS_SUCCESS]: customersSuccess,
    [CustomersTypes.CUSTOMERS_COUNT_SUCCESS]: customersCountSuccess,
    [CustomersTypes.CUSTOMER_IMPORTS_SUCCESS]: customerImportsSuccess,
    [CustomersTypes.CUSTOMER_IMPORT_SUCCESS]: customerImportSuccess,
    [CustomersTypes.UPLOAD_SUCCESS]: uploadSuccess,
    [CustomersTypes.APPLY_UPLOAD_SUCCESS]: applyUploadSuccess,
    [CustomersTypes.ENTRIES_SUCCESS]: entriesSuccess,
    [CustomersTypes.AUDIENCE_MEMBERS_SUCCESS]: audienceMembersSuccess,
    [CustomersTypes.AUDIENCE_CANDIDATE_SEGMENTS_SUCCESS]: audienceCandidateSegmentsSuccess,
    [CustomersTypes.AUDIENCE_CANDIDATE_TAGS_SUCCESS]: audienceCandidateTagsSuccess,
    [CustomersTypes.SAVE_AUDIENCE_CANDIDATE_METADATA_SUCCESS]: saveAudienceCandidateMetadataSuccess,
    [CustomersTypes.APPLY_AUDIENCE_CANDIDATES_SUCCESS]: applyAudienceCandidatesSuccess,
    [CustomersTypes.AUDIENCE_BULK_INVITATIONS_SUCCESS]: audienceBulkInvitationsSuccess,
    [CustomersTypes.AUDIENCE_BATCHES_SUCCESS]: audienceBatchesSuccess,
    [CustomersTypes.DOWNLOAD_CSV_SUCCESS]: downloadCsvSuccess,
    [CustomersTypes.DOWNLOAD_AUDIENCE_CSV_SUCCESS]: downloadAudienceCsvSuccess,
    [CustomersTypes.SUBMIT_CUSTOMER_ENRICHMENT_SUCCESS]: submitCustomerEnrichmentSuccess,
    [CustomersTypes.CUSTOMER_ENRICHMENTS_SUCCESS]: customerEnrichmentsSuccess,
    [CustomersTypes.CUSTOMER_ENRICHMENT_STATUS_SUCCESS]: customerEnrichmentStatusSuccess,
    [CustomersTypes.CUSTOMER_ENRICHMENT_ITEMS_SUCCESS]: customerEnrichmentItemsSuccess,
    [CustomersTypes.BULK_PLAN_INVITE_SUCCESS]: bulkPlanInviteSuccess,
    [CustomersTypes.BUSINESS_CUSTOMER_RECORD_SUCCESS]: businessCustomerRecordSuccess,
    [CustomersTypes.LINK_BUSINESS_CUSTOMER_SUCCESS]: linkBusinessCustomerSuccess,
    [CustomersTypes.UNLINK_BUSINESS_CUSTOMER_SUCCESS]: unlinkBusinessCustomerSuccess,
    [CustomersTypes.CANONICAL_BUSINESS_CUSTOMER_SUCCESS]: canonicalBusinessCustomerSuccess,
    [CustomersTypes.BUSINESS_CUSTOMER_SUMMARY_SUCCESS]: businessCustomerSummarySuccess,
    [CustomersTypes.SECONDARY_BUSINESS_CUSTOMERS_SUCCESS]: secondaryBusinessCustomersSuccess,
    [CustomersTypes.SECONDARY_BUSINESS_CUSTOMERS_COUNT_SUCCESS]: secondaryBusinessCustomersCountSuccess,
    [CustomersTypes.CREATE_BUSINESS_CUSTOMER_SUCCESS]: createBusinessCustomerSuccess,
    [CustomersTypes.UPDATE_BUSINESS_CUSTOMER_SIMPLE_SUCCESS]: updateBusinessCustomerSimpleSuccess,
    [CustomersTypes.CREATE_AUDIENCE_SUCCESS]: createAudienceSuccess,

    [CustomersTypes.CUSTOMER_FAILURE]: customersFailure,
    [CustomersTypes.CUSTOMERS_COUNT_FAILURE]: customersCountFailure,
    [CustomersTypes.CUSTOMER_IMPORTS_FAILURE]: customerImportsFailure,
    [CustomersTypes.CUSTOMER_IMPORT_FAILURE]: customerImportFailure,
    [CustomersTypes.UPLOAD_FAILURE]: uploadFailure,
    [CustomersTypes.APPLY_UPLOAD_FAILURE]: applyUploadFailure,
    [CustomersTypes.ENTRIES_FAILURE]: entriesFailure,
    [CustomersTypes.AUDIENCE_MEMBERS_FAILURE]: audienceMembersFailure,
    [CustomersTypes.AUDIENCE_CANDIDATE_SEGMENTS_FAILURE]: audienceCandidateSegmentsFailure,
    [CustomersTypes.AUDIENCE_CANDIDATE_TAGS_FAILURE]: audienceCandidateTagsFailure,
    [CustomersTypes.SAVE_AUDIENCE_CANDIDATE_METADATA_FAILURE]: saveAudienceCandidateMetadataFailure,
    [CustomersTypes.APPLY_AUDIENCE_CANDIDATES_FAILURE]: applyAudienceCandidatesFailure,
    [CustomersTypes.AUDIENCE_BULK_INVITATIONS_FAILURE]: audienceBulkInvitationsFailure,
    [CustomersTypes.AUDIENCE_BATCHES_FAILURE]: audienceBatchesFailure,
    [CustomersTypes.DOWNLOAD_CSV_FAILURE]: downloadCsvFailure,
    [CustomersTypes.DOWNLOAD_AUDIENCE_CSV_FAILURE]: downloadAudienceCsvFailure,
    [CustomersTypes.SUBMIT_CUSTOMER_ENRICHMENT_FAILURE]: submitCustomerEnrichmentFailure,
    [CustomersTypes.CUSTOMER_ENRICHMENTS_FAILURE]: customerEnrichmentsFailure,
    [CustomersTypes.CUSTOMER_ENRICHMENT_STATUS_FAILURE]: customerEnrichmentStatusFailure,
    [CustomersTypes.CUSTOMER_ENRICHMENT_ITEMS_FAILURE]: customerEnrichmentItemsFailure,
    [CustomersTypes.BULK_PLAN_INVITE_FAILURE]: bulkPlanInviteFailure,
    [CustomersTypes.BUSINESS_CUSTOMER_RECORD_FAILURE]: businessCustomerRecordFailure,
    [CustomersTypes.LINK_BUSINESS_CUSTOMER_FAILURE]: linkBusinessCustomerFailure,
    [CustomersTypes.UNLINK_BUSINESS_CUSTOMER_FAILURE]: unlinkBusinessCustomerFailure,
    [CustomersTypes.CANONICAL_BUSINESS_CUSTOMER_FAILURE]: canonicalBusinessCustomerFailure,
    [CustomersTypes.BUSINESS_CUSTOMER_SUMMARY_FAILURE]: businessCustomerSummaryFailure,
    [CustomersTypes.SECONDARY_BUSINESS_CUSTOMERS_FAILURE]: secondaryBusinessCustomersFailure,
    [CustomersTypes.SECONDARY_BUSINESS_CUSTOMERS_COUNT_FAILURE]: secondaryBusinessCustomersCountFailure,
    [CustomersTypes.CREATE_BUSINESS_CUSTOMER_FAILURE]: createBusinessCustomerFailure,
    [CustomersTypes.UPDATE_BUSINESS_CUSTOMER_SIMPLE_FAILURE]: updateBusinessCustomerSimpleFailure,
    [CustomersTypes.CREATE_AUDIENCE_FAILURE]: createAudienceFailure
})